import type { ReportDataTableColumn } from '../../components/ReportDataTable'
import type { ConfiguredReportReportRow } from '../../types/pages'
import { display, makeLink } from '../../utils/configuredReportFormatters'

export const nonVerifiedColumns: ReportDataTableColumn<ConfiguredReportReportRow, string>[] = [
  {
    id: 'company_name',
    label: 'Company',
    sortKey: 'company_name',
    render: (row) =>
      row.company_id
        ? makeLink(
            `/company/edit/${row.company_id}`,
            display(row.company_name),
            true,
          )
        : display(row.company_name),
  },
  {
    id: 'property_name',
    label: 'Property',
    sortKey: 'property_name',
    render: (row) =>
      row.property_id
        ? makeLink(
            `/property/edit/${row.property_id}`,
            display(row.property_name),
            true,
          )
        : display(row.property_name),
  },
  {
    id: 'team_name',
    label: 'Sales Team',
    sortKey: 'fk_sales_team_id',
    render: (row) => display(row.team_name),
  },
  {
    id: 'payment_method',
    label: 'Payment Method',
    sortKey: 'payment_method',
    render: (row) => display(row.payment_method),
  },
  {
    id: 'payee_name',
    label: 'Payee User Name',
    sortKey: 'payee_user_name',
    render: (row) => display(row.payee_name),
  },
  {
    id: 'payment_address',
    label: 'Address',
    sortKey: 'payment_address',
    render: (row) => display(row.payment_address),
  },
  {
    id: 'payment_city',
    label: 'City',
    sortKey: 'payment_city',
    render: (row) => display(row.payment_city),
  },
  {
    id: 'payment_state',
    label: 'State',
    sortKey: 'payment_state',
    render: (row) => display(row.payment_state),
  },
  {
    id: 'payment_zipcode',
    label: 'Zip',
    sortKey: 'payment_zipcode',
    render: (row) => display(row.payment_zipcode),
  },
]
